<mobile-navbar
  *ngIf="state === 'menu'; else settingsPage"
  [title]="'Settings'"
  (onLeftButtonClick)="onHamburgerClick.emit()"
></mobile-navbar>

<ng-template #settingsPage>
  <mobile-navbar
    [title]="getStateTitle()"
    [leftButtonIcon]="'arrow_back'"
    (onLeftButtonClick)="state = 'menu'"
  ></mobile-navbar>
</ng-template>

<div [ngSwitch]="state" class="p-4 pt-8">
  <div *ngSwitchCase="'preferences'">
    <settings-for-preferences></settings-for-preferences>
  </div>
  <div *ngSwitchCase="'account'">
    <settings-for-account
      (onOpenLoginRequested)="onOpenLoginClick.emit()"
    ></settings-for-account>
  </div>
  <div *ngSwitchCase="'prefund_pro'">
    <settings-for-prefund-pro></settings-for-prefund-pro>
  </div>
  <div *ngSwitchCase="'advanced'">
    <settings-for-advanced></settings-for-advanced>
  </div>
  <div *ngSwitchCase="'about'">
    <settings-for-about></settings-for-about>
  </div>
  <settings-menu
    *ngSwitchDefault
    (menuItemClicked)="state = $event"
  ></settings-menu>
</div>
